export const toFixed = (value: number) => {
  if (!value) { return ''; }
  return (Math.floor(value * 100) / 100).toFixed(2);
};

export const formatPrice = (price: number) => {
  const numberWithComma = new Intl.NumberFormat();
  return numberWithComma.format(price);
};
